/**
 * Displays list of Binance balances
 */
import { useSelector } from 'react-redux';
import { ICEXBalanceItem } from '@kattana-io/common';
import Text from '../../../../atoms/Text';
import FallbackImage from '../../../../atoms/Image/Fallback';
import { getCDNIcon } from '../../../../helpers/coinIcon';
import { getExchangeInfo } from '../../../../selectors/cex';
import NumberDisplay from '../../../../molecules/NumberDisplay';

const CexBalances = () => {
  const { activeExchange } = useSelector(getExchangeInfo);
  const balances = activeExchange?.balance || [];

  if (!activeExchange?.enable) {
    return (
      <Text size={12} className='warning'>
        Could not fetch balance of your wallet
      </Text>
    );
  }

  return (
    <div className='balances_coins_list'>
      {balances.map((item: ICEXBalanceItem) => (
        <div
          key={item.coin}
          className='balances_coins_list__item balances_coins_list__item--disabled'
        >
          <FallbackImage
            size='l'
            src={getCDNIcon(item.coin)}
            fallback={<div className='token__fallback'>{item.coin[0]}</div>}
          />
          <div className='balances_coins_list__item__balance_info'>
            <Text
              style={{ title: item.available.toString() }}
              size={14}
              className='text--weight-600 text--grey-400'
            >
              {item.coin}
            </Text>
            <Text size={12} className='text--grey-400'>
              <NumberDisplay value={item.total} string />
              &nbsp;
              <NumberDisplay
                value={item.available}
                startSymbol='(available: '
                endSymbol=')'
                string
              />
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CexBalances;
